import React, { FC, MouseEvent, ReactNode, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { addDays } from "date-fns";

import { Button, Variant } from "../../common";
import { useTriggerToastOnRTKError } from "../../../hooks/useTriggerToastOnRTKError";
import { ROUTES } from "../../../routes";
import { selectCurrentUser } from "../../../store/reducers/user";
import { useCreateInvoiceMutation } from "../../../store/services/invoices";
import { DateFormat, formatDate } from "../../../utils/date";

type Props = {
  className?: string;
  contentClassName?: string;
  children: ReactNode;
  variant?: Variant;
};

export const CreateInvoiceAction: FC<Props> = ({
  className,
  contentClassName,
  children,
  variant = Button.variant.PRIMARY,
}) => {
  const navigate = useNavigate();

  const { id: userId } = useSelector(selectCurrentUser);

  const [createInvoice, { data: newInvoice, isSuccess, isError, error }] =
    useCreateInvoiceMutation();

  useTriggerToastOnRTKError(isError, error);

  const handler = async (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    await createInvoice({
      issuer_id: userId,
      issued_at: formatDate(new Date().toString(), DateFormat.yyyy_MM_dd),
      due_at: formatDate(
        addDays(new Date(), 14).toString(),
        DateFormat.yyyy_MM_dd
      ),
    });
  };

  useEffect(() => {
    if (isSuccess) {
      newInvoice && navigate(ROUTES.INVOICE.replace(":id", newInvoice.id));
    }
  }, [isSuccess, navigate, newInvoice]);

  return (
    <Button
      className={className}
      contentClassName={contentClassName}
      onClick={handler}
      variant={variant}
      data-test="create-invoice-btn"
    >
      {children}
    </Button>
  );
};
